<template>
    <div class="form-container">
        <login-user-session-active
            v-if="pStore.isAuthenticated"
            :skip-get-form="skipGetForm"
            :redirect-to="redirectTo"
        >
        </login-user-session-active>
        <login
            v-else
            :show-continue-without-login="showContinueWithoutLogin"
            :skip-get-form="skipGetForm"
            :redirect-to="redirectTo"
        ></login>
    </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { usePiniaStore } from "@/plugins/store";

import login from "@/templates/login.vue";
import loginUserSessionActive from "@/templates/loginUserSessionActive.vue";

import { routeNames } from "@/constants/routeNames";

const pStore = usePiniaStore();
const eMandatesLogin = computed(() =>
    window.location.href.includes("e-mandates"),
);
const showContinueWithoutLogin = computed(() => !eMandatesLogin.value);
const skipGetForm = computed(() => eMandatesLogin.value);
const redirectTo = computed(() =>
    eMandatesLogin.value
        ? routeNames.E_MANDATES_FORM
        : routeNames.SUPPLEMENTARY_FORM,
);
</script>
